<template>
  <div :class="stageKey">
    <v-stage
      ref="stage"
      :key="stageKey"
      :config="{...config, isStatic}"
      @mousedown="mouseDown"
      @mouseup="$emit('mouse:up', $event)"
      @touchstart="mouseDown"
      @touchend="$emit('mouse:up', $event)"
      @click="$emit('click', $event)"
      @tap="$emit('click', $event)"
      @dblclick="$emit('click:dbl', $event)"
      @tbltap="$emit('click:dbl', $event)"
      @dragstart="$emit('drag:start', $event)"
      @dragend="$emit('drag:end', $event, transformerTargetName)"
    > 
      <v-layer v-if="layers == null">
        <slot :stageKey="stageKey" />
      </v-layer>
      <template v-else>
        <v-layer 
          v-for="l in parseInt(layers)"
          :key="`${stageKey}-layer-${l}`"
        >
          <slot 
            :name="`layer-${l}`"
            :bottom="l === 1"
            :top="l == layers"
            :stageKey="stageKey"
          />
        </v-layer>
      </template>
      <v-layer v-if="!isStatic">
        <transformer 
          ref="transformer"
          :stage-key="stageKey"
          :stage-allow-scale="allowTransformerScale"
          :stage-allow-stretch="allowTransformerStretch"
          :stage-allow-rotate="allowTransformerRotate" 
          @select-stage="$emit('click:stage')"
          @transform:start="$emit('transform:start', $event)"
          @transform:end="$emit('transform:end', $event)"
        />
      </v-layer>
    </v-stage>
  </div>
</template>

<script>
import Transformer from './helpers/Transformer.vue'
export default {
  name: 'Stage',
  components: {Transformer},
  props: {
    config: {
      type: Object,
      default () {return {}}
    },
    allowTransformerStretch: {
      type: Boolean,
      default: true
    },
    allowTransformerScale: {
      type: Boolean,
      default: true
    },
    allowTransformerRotate: {
      type: Boolean,
      default: true
    },
    isStatic: Boolean,
    nameField: {
      type: String,
      default: 'name'
    },
    hideTransformer: Boolean,
    layers: {
      validator (value) {return !isNaN(value)}
    },
  },
  data () {
    return {selectedElement: undefined}
  },
  computed: {
    stageKey () {return this.config[this.nameField]},
    transformerTargetName () {
      const {attrs} = this. selectedElement
      return attrs?.transformerTargetName || attrs?.baseName || null
    }
  },
  mounted () {
    if (!this.config[this.nameField]) 
      console.error(`"${this.nameField}" not defined in stage "config"`, this.config)
  },
  methods: {
    print () {
      const data = this.$refs.stage?.getNode().toDataURL({})
      const link = document.createElement('a')
      link.href = data
      link.download = 'floor_plan.png'
      link.click()
    },
    mouseDown (event) {
      this.$refs.transformer?._setTransformer(event)
      this.selectedElement = event.target
      this.$emit('mouse:down', event)
    },
    setAllowStretch (value) {
      this.$refs.transformer?._setAnchorAllowance({allowStretch: value})
    },
    clearTransformer () {this.$refs.transformer?._clearTransformer()}
  }
}
</script>